import { Button, ButtonGroup } from "@shopify/polaris";
import { t } from "i18next";
import Modal from "../Modal";
import React from "react";
import { useSelector } from "react-redux";
import { logout } from "../../redux/features/auth/authSlice";
import useAppDispatch from "hooks/useAppDispatch";
import { getLoginUrlWithReturn } from "utils/authReturnUrl";
import { clearAuthClientState } from "utils/cookie";
import { beginLogoutTransition } from "utils/logoutTransition";

const redirectToLogin = () => {
  const loginUrl = getLoginUrlWithReturn();
  if (loginUrl.startsWith("http")) {
    window.location.replace(loginUrl);
    return;
  }
  window.location.assign(loginUrl);
};

const LogoutModal = ({ visible, onClose }) => {
  const dispatch = useAppDispatch();
  const { loggingOut } = useSelector((state) => state.auth);

  const onLogout = async () => {
    beginLogoutTransition();
    try {
      await dispatch(logout());
    } finally {
      clearAuthClientState();
      redirectToLogin();
    }
  };

  return (
    <Modal
      title={t("profile.logOut")}
      visible={visible}
      contentOnCenter
      onClose={onClose}
      iconType={"warning"}
      description={t("profile.sureLogout")}
      footer={
        <ButtonGroup fullWidth>
          <Button size="large" onClick={onClose} disabled={loggingOut}>
            {t("profile.no")}
          </Button>
          <Button
            variant="primary"
            tone="critical"
            size="large"
            onClick={onLogout}
            loading={loggingOut}
            disabled={loggingOut}
          >
            {t("profile.yes")}
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default LogoutModal;
